import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { SubscriptionOrderModal } from '../../components/ConfirmModal';
import { hideSpinner, showSpinner } from '../../modules/global/actions';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { selectErrors } from '../../modules/global/selectors';
import { TextModal } from '../../components/Modal';
import { fetchFreeNumbers } from '../../modules/emptySims/actions';
import { orderSubscriptions } from '../../modules/simCards/actions';
import { selectOrderSubscriptionsFinished } from '../../modules/simCards/selectors';
import { selectCustomerData, selectCustomerContactData } from '../../modules/customer/selectors';
import { makeSelectFreeNumbers } from '../../modules/emptySims/selectors';
import SubscriptionsOrderContent from './SubscriptionsOrderContent';
import { validate } from '../../utils/validators';
import styled from 'styled-components';
import { getAccountId } from '../../utils/helpers';
import { ApiRequest } from '../../utils/api';
import { gaB2COrderMoreSubscriptions } from '../../utils/analytics';
import { OfferingType } from '../../utils/offeringType';
import { ErrorCodeReason, findErrorByErrorCodeReason } from '../../utils/error';

const OrderingDisabled = styled.div`
	font-size: 26px;
	margin-top: 3rem;
`;

const StyledLink = styled.a`
	color: red;
`;

const acceptTermsText = 'Hyväksy palvelu- ja sopimusehdot ennen jatkamista.';
const checkFieldsText = 'Tarkista kentät';
const checkTransferNumberAutomaticallyText = 'Hyväksy automaattinen numeroiden siirto numeronsiirrot kohdasta';

class SubscriptionsOrderPage extends React.PureComponent {
	// eslint-disable-line react/prefer-stateless-function
	constructor(props) {
		super(props);
		this.state = {
			freeNumbers: null,
			freeNumbersModified: false,
			subscriptionsToOrder: [],
			selectedSubscription: {
				subscriptionName: { value: '', valid: null },
				msisdn: { value: '', valid: null },
				packageSpecs: { value: null, valid: null },
				isMnp: true,
				showInBasket: false // determines if current subscription edited, can be shown into shoppingbasket/cart --> can you add it to cart and do order with it.
			},
			msisdnTransferDate: null,
			transferNumberAutomatically: false,
			termsAccepted: false,
			billingAddress: {
				recipientName: { value: '', valid: null },
				streetAddress: { value: '', valid: null },
				postalCode: { value: '', valid: null },
				city: { value: '', valid: null }
			},
			formSubmitted: false,
			passwordModalIsOpen: false,
			orderJSON: null,
			showErrors: false,
			restrictions: undefined,
			restrictionFetchError: undefined
		};
		this.myRef = null;
	}

	componentDidMount() {
		this.props.doShowSpinner();
		ApiRequest.getRestrictions(getAccountId())
			.execute()
			.then((response) => {
				this.setState({
					restrictions: response,
					restrictionFetchError: false
				});
				this.props.doHideSpinner();
			})
			.catch((error) => {
				// Error modal is not opened for this error, just something went wrong message on page is shown
				this.setState({
					restrictionFetchError: true
				});
				this.props.doHideSpinner();
			});
	}

	UNSAFE_componentWillMount() {
		const { doFetchFreeNumbers } = this.props;
		doFetchFreeNumbers();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.freeNumbers && !this.state.freeNumbersModified) {
			this.setState({
				freeNumbers: nextProps.freeNumbers.toJS()
			});
		}
	}

	setRef = (ref) => {
		this.myRef = ref;
	};

	setErrorsVisibleAndRenderModal = (modalContent) => {
		this.setState({
			showErrors: true,
			modalIsOpen: true,
			modalContent
		});
	};

	handleFieldChange = (e) => {
		const valid = validate(e.target.value, e.target.name);
		this.setState({
			selectedSubscription: {
				...this.state.selectedSubscription,
				[e.target.name]: { value: e.target.value, valid }
			}
		});
	};

	handleBillingAddressChange = (e) => {
		const valid = validate(e.target.value, e.target.name);
		this.setState({
			billingAddress: {
				...this.state.billingAddress,
				[e.target.name]: { value: e.target.value, valid }
			}
		});
	};

	handleProductPackageChange = (value) => {
		this.setState({
			selectedSubscription: {
				...this.state.selectedSubscription,
				packageSpecs: { value, valid: true },
				showInBasket: true
			}
		});
	};

	checkValidityOfFields = () => {
		let fieldsValid = true;
		if (!this.state.selectedSubscription.showInBasket && this.state.selectedSubscription.packageSpecs.valid) {
			return true;
		}
		const subscriptionKeys = Object.keys(this.state.selectedSubscription);
		const billingAddressKeys = Object.keys(this.state.billingAddress);
		subscriptionKeys.forEach((key) => {
			if (Object.prototype.hasOwnProperty.call(this.state.selectedSubscription[key], 'valid') && !this.state.selectedSubscription[key].valid) {
				fieldsValid = false;
			}
		});
		billingAddressKeys.forEach((key) => {
			if (Object.prototype.hasOwnProperty.call(this.state.billingAddress[key], 'valid') && !this.state.billingAddress[key].valid) {
				fieldsValid = false;
			}
		});
		return fieldsValid;
	};

	addNewSubscriptionToBasket = () => {
		const valid = this.checkValidityOfFields();
		if (valid && this.state.selectedSubscription.showInBasket) {
			const newSubscription = {
				id: `id${Math.random().toString(36).substr(2, 9)}`,
				...this.state.selectedSubscription
			};
			if (!this.state.selectedSubscription.isMnp) {
				const freeNumbers = this.state.freeNumbers;
				const reservedNumberForSubscription = this.state.selectedSubscription.msisdn.value;
				const trimmedNumbers = freeNumbers.filter((val) => val.msisdn !== reservedNumberForSubscription);
				this.setState({
					freeNumbers: trimmedNumbers,
					freeNumbersModified: true
				});
			}
			this.setState({
				subscriptionsToOrder: [...this.state.subscriptionsToOrder, newSubscription],
				selectedSubscription: {
					subscriptionName: { value: '', valid: null },
					msisdn: { value: '', valid: null },
					packageSpecs: { value: null, valid: null },
					isMnp: true,
					showInBasket: false
				},
				showErrors: false
			});
			this.scrollToShoppingCart();
		} else {
			this.setErrorsVisibleAndRenderModal(checkFieldsText);
		}
	};

	removeSubscriptionFromBasket = (removable) => {
		const subscriptionsToOrder = this.state.subscriptionsToOrder;
		const trimmedArray = _.filter(subscriptionsToOrder, (object) => object.id !== removable.id);
		this.setState({
			subscriptionsToOrder: trimmedArray
		});
	};

	scrollToShoppingCart = () => {
		window.scrollTo({ top: this.myRef.offsetTop, behavior: 'smooth' });
	};

	hasMnpSubscriptions = () => {
		if (this.state.selectedSubscription.showInBasket && this.state.selectedSubscription.isMnp) {
			return true;
		}
		let mnpFound = false;
		this.state.subscriptionsToOrder.forEach((subscription) => {
			if (subscription.isMnp) {
				mnpFound = true;
			}
		});
		return mnpFound;
	};

	trySubmitOrder = () => {
		const valid = this.checkValidityOfFields();
		if ((valid && this.state.selectedSubscription.showInBasket) || (valid && this.state.subscriptionsToOrder.length > 0)) {
			if (!this.state.termsAccepted) {
				this.setErrorsVisibleAndRenderModal(acceptTermsText);
			} else if (this.hasMnpSubscriptions() && !this.state.transferNumberAutomatically) {
				this.setErrorsVisibleAndRenderModal(checkTransferNumberAutomaticallyText);
			} else {
				const orderJSON = this.constructOrderJSON(this.getSubscriptionsForOrder());
				this.setState({
					passwordModalIsOpen: true,
					orderJSON
				});
			}
		} else {
			this.setErrorsVisibleAndRenderModal(checkFieldsText);
		}
	};

	getSubscriptionsForOrder = () => {
		const newSubscription = {
			id: `id${Math.random().toString(36).substr(2, 9)}`,
			...this.state.selectedSubscription
		};
		let subscriptionsToOrder;
		if (newSubscription.showInBasket) {
			subscriptionsToOrder = [...this.state.subscriptionsToOrder, newSubscription];
		} else {
			subscriptionsToOrder = this.state.subscriptionsToOrder;
		}
		return subscriptionsToOrder;
	};

	submitOrder = () => {
		this.props.doOrderSubscriptions(this.state.orderJSON);
		if (this.props.offeringType === OfferingType.CONSUMER4) {
			gaB2COrderMoreSubscriptions(this.getSubscriptionsForOrder(), this.calculateTotalPrice());
		}
		this.setState({
			formSubmitted: true,
			passwordModalIsOpen: false
		});
	};

	onThankYouViewOkButtonClick = () => {
		this.props.history.replace('/account/sims'); // eslint-disable-line
	};

	closeModal = () => {
		this.setState({
			modalIsOpen: false
		});
	};

	closePasswordModal = () => {
		this.setState({
			passwordModalIsOpen: false
		});
	};

	constructOrderJSON = (subscriptionsToOrder) => {
		const orderJSON = {
			delivery: {
				recipientName: this.state.billingAddress.recipientName.value,
				streetAddress: this.state.billingAddress.streetAddress.value,
				postalCode: this.state.billingAddress.postalCode.value,
				city: this.state.billingAddress.city.value
			},
			termsAndConditions: {
				termsAccepted: this.state.termsAccepted,
				marketing: null
			},
			portFixedTerm: this.state.transferNumberAutomatically,
			order: {
				subscriptions: []
			}
		};
		_.forEach(subscriptionsToOrder, (subscription) => {
			const individualSubscriptionJSON = {
				name: subscription.subscriptionName.value,
				packageType: subscription.packageSpecs.value.orderItemCode,
				isMnp: subscription.isMnp,
				msisdn: subscription.msisdn.value
			};
			orderJSON.order.subscriptions.push(individualSubscriptionJSON);
		});
		return orderJSON;
	};

	switchNumsiOn = () => {
		if (!this.state.selectedSubscription.isMnp) {
			this.setState({
				selectedSubscription: {
					...this.state.selectedSubscription,
					msisdn: { value: '', valid: false },
					isMnp: true
				}
			});
		}
	};

	calculateTotalPrice = () => {
		let totalPrice = 0;
		_.forEach(this.getSubscriptionsForOrder(), (subscription) => {
			if (subscription.packageSpecs.value !== null) {
				totalPrice += subscription.packageSpecs.value.eurPerMonth;
			}
		});
		return totalPrice;
	};

	switchNumsiOff = () => {
		if (this.state.selectedSubscription.isMnp) {
			this.setState({
				selectedSubscription: {
					...this.state.selectedSubscription,
					msisdn: { value: this.state.freeNumbers[0].msisdn, valid: true },
					isMnp: false
				}
			});
		}
	};

	transferNumberAutomaticallyHandler = () => {
		this.setState({
			transferNumberAutomatically: !this.state.transferNumberAutomatically
		});
	};

	termsCheckBoxHandler = () => {
		this.setState({
			termsAccepted: !this.state.termsAccepted
		});
	};

	eraseCurrentSubscription = () => {
		this.setState({
			selectedSubscription: {
				subscriptionName: { value: '', valid: null },
				msisdn: { value: '', valid: null },
				packageSpecs: { value: null, valid: null },
				isMnp: true,
				showInBasket: false
			},
			showErrors: false
		});
	};

	getErrorCodeBasedMessage = (errors) => {
		const msisdnInUseError = findErrorByErrorCodeReason(errors, ErrorCodeReason.MSISDN_IN_USE);
		if (msisdnInUseError !== undefined) {
			return (
				msisdnInUseError.message +
				'. Jos tarkoituksesi oli siirtää Moilla jo oleva numero tälle tilille tai tarvitset nykyiselle liittymällesi uuden SIM-kortin, olethan yhteydessä asiakaspalveluumme. '
			);
		}
		const duplicateMsisdnsError = findErrorByErrorCodeReason(errors, ErrorCodeReason.DUPLICATE_MSISDNS);
		if (duplicateMsisdnsError !== undefined) {
			return duplicateMsisdnsError.message;
		}
		return undefined;
	};

	ScrollToTop = () => {
		if (this.state.formSubmitted) {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	};

	render() {
		this.ScrollToTop();
		const { errors, freeNumbers, offeringType } = this.props;
		const noErrors = errors && errors.length < 1 && this.state.restrictionFetchError !== undefined && this.state.restrictionFetchError === false;
		const errorCodeBasedMessage = this.getErrorCodeBasedMessage(errors);
		const monthlyCostTotal = this.calculateTotalPrice();
		if (this.state.restrictions !== undefined && _.findIndex(this.state.restrictions, (restriction) => restriction.id === 'ADDITIONAL_ORDERS_BLOCKED') !== -1) {
			return (
				<OrderingDisabled>
					Hups. Simmisi tulee päivittää uusiin tuotteisiimme <StyledLink href="#/account/offeringChange"> tästä </StyledLink>, niin voit tilata lisää uuden sukupolven tuotteitamme! Jos et nyt halua
					tehdä mitään, odota että vanhat simmisi päivittyvät automaattisesti 1.11. alkaen laskutuskautesi vaihtuessa. Ja kokeile sen jälkeen lisätilausta, pitäisi pelittää!
				</OrderingDisabled>
			);
		} else {
			return (
				<article>
					{freeNumbers && noErrors && (
						<SubscriptionsOrderContent
							{...this.state}
							{...this.props}
							onFieldChange={this.handleFieldChange}
							onBillingAddressChange={this.handleBillingAddressChange}
							onProductPackageChange={this.handleProductPackageChange}
							onSubmit={this.trySubmitOrder}
							onSubscriptionAdd={this.addNewSubscriptionToBasket}
							onSubscriptionRemove={this.removeSubscriptionFromBasket}
							freeNumbers={this.state.freeNumbers}
							setRef={this.setRef}
							monthlyCostTotal={monthlyCostTotal}
							switchNumsiOn={this.switchNumsiOn}
							switchNumsiOff={this.switchNumsiOff}
							transferNumberAutomaticallyHandler={this.transferNumberAutomaticallyHandler}
							termsCheckBoxHandler={this.termsCheckBoxHandler}
							onThankYouViewOkButtonClick={this.onThankYouViewOkButtonClick}
							eraseCurrentSubscription={this.eraseCurrentSubscription}
							hasMnpSubscriptions={this.hasMnpSubscriptions}
						/>
					)}
					{this.state.orderJSON !== null && (
						<SubscriptionOrderModal
							isOpen={this.state.passwordModalIsOpen}
							onRequestClose={this.closePasswordModal}
							onConfirm={this.submitOrder}
							title={'Vahvista osto'}
							subscriptions={this.getSubscriptionsForOrder()}
							monthlyCostTotal={monthlyCostTotal}
							offeringType={offeringType}
						/>
					)}
					<TextModal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} content={this.state.modalContent} />
					{!noErrors && this.state.restrictionFetchError !== undefined && errorCodeBasedMessage !== undefined && <Error message={errorCodeBasedMessage} />}
					{!noErrors && this.state.restrictionFetchError !== undefined && errorCodeBasedMessage === undefined && (
						<Error message={'Jotain meni vikaan. Yritä myöhemmin uudestaan tai ota yhteyttä asiakaspalveluumme'} />
					)}
				</article>
			);
		}
	}
}

SubscriptionsOrderPage.propTypes = {
	errors: PropTypes.array,
	doFetchFreeNumbers: PropTypes.func,
	freeNumbers: PropTypes.object,
	doOrderSubscriptions: PropTypes.func,
	customerContactData: PropTypes.object,
	doAuthorizePassword: PropTypes.func,
	doResetAuthorization: PropTypes.func,
	offeringType: PropTypes.string,
	doShowSpinner: PropTypes.func,
	doHideSpinner: PropTypes.func
};

const mapStateToProps = (state) => {
	const errors = selectErrors(state);
	const customerData = selectCustomerData(state);
	const selectFreeNumbers = makeSelectFreeNumbers();
	const freeNumbers = selectFreeNumbers(state);
	const orderSubscriptionsFinished = selectOrderSubscriptionsFinished(state);
	const customerContactData = selectCustomerContactData(state);
	return {
		errors,
		customerData,
		freeNumbers,
		orderSubscriptionsFinished,
		customerContactData
	};
};

const mapDispatchToProps = (dispatch) => ({
	doFetchFreeNumbers: () => dispatch(fetchFreeNumbers()),
	doOrderSubscriptions: (order) => dispatch(orderSubscriptions(order)),
	doShowSpinner: () => dispatch(showSpinner()),
	doHideSpinner: () => dispatch(hideSpinner())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubscriptionsOrderPage));
